import React from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RadioPanelGroupTheme } from './common/RadioPanelGroupTheme';
import { RadioPanelBorderRadius } from './common/RadioPanelBorderRadius';
import { RadioPanelDropShadowType } from './common/RadioPanelDropShadowType';

export const RadioPanel: React.FC<{
    id: string;
    children: any;
    selectedPanels?: string[]; //Should be passed into parent group control
    set_selectedPanels?: (panelNumber: string[]) => void; //Should be passed into parent group control
    selectionType?: 'single' | 'multiple'; //Should be passed into parent group control
    maxSelection?: number; //Should be passed into parent group control
    borderRadius?: RadioPanelBorderRadius; //Should be passed into parent group control
    dropShadowType?: RadioPanelDropShadowType; //Should be passed into parent group control
    wrapPanels?: boolean; //Should be passed into the parent group control
    panelWidth?: string; //Should be passed into the parent group control - only applicable for wrapPanels
    handleClick?: React.MouseEventHandler;
    enabled?: boolean;
    theme?: RadioPanelGroupTheme;
}> = ({
    id,
    children,
    selectionType = 'single',
    selectedPanels,
    set_selectedPanels,
    maxSelection,
    borderRadius = RadioPanelBorderRadius.None,
    dropShadowType = RadioPanelDropShadowType.None,
    wrapPanels = false,
    panelWidth = '100%',
    handleClick,
    enabled = true,
    theme = RadioPanelGroupTheme.Blue,
}) => {
    const setStyle = {
        cursor: `${enabled ? 'pointer' : 'arrow'}`,
        maxWidth: `${wrapPanels ? panelWidth : '100%'}`,
    };

    const performClick = (e: React.MouseEvent) => {
        if (enabled) {
            //Do Update of selection
            updateSelections(e);

            //Perform any additional selection click action passed to the control
            if (handleClick) {
                handleClick(e);
            }
        }
    };

    const updateSelections = (e: React.MouseEvent) => {
        if (e.currentTarget != undefined) {
            const currentId = e.currentTarget.id;
            if (set_selectedPanels != undefined) {
                if (selectionType == 'single') {
                    set_selectedPanels([currentId]);
                } else {
                    if (!maxSelection || (selectedPanels != undefined && selectedPanels?.length <= maxSelection)) {
                        set_selectedPanels((currentArray) => {
                            const index = currentArray.indexOf(currentId);
                            if (index > -1) {
                                // Replace existing string
                                return currentArray.filter((item: string) => item !== currentId);
                            } else if (!maxSelection || (selectedPanels != undefined && selectedPanels?.length < maxSelection)) {
                                // Add new string
                                return [...currentArray, currentId];
                            } else {
                                return currentArray;
                            }
                        });
                    }
                }
            }
        }
    };

    return (
        <>
            <div
                id={id}
                className={`radioPanel ${theme} ${borderRadius} ${dropShadowType} ${wrapPanels ? 'wrapped' : 'unwrapped'} ${selectedPanels?.some((panel) => panel === id) ? 'selected' : ''}`}
                key={`radioPanel_${id}`}
                onClick={performClick}
                style={setStyle}
            >
                <div className='rbPanel-content'>
                    <div className={`rbPanel-button ${theme} ${selectedPanels?.some((panel) => panel === id) ? 'selected' : ''}`}>
                        {selectedPanels?.some((panel) => panel === id) && <FontAwesomeIcon icon={faCheck} />}
                    </div>
                    <div className='rbPanel-children'>{children}</div>
                </div>
            </div>
        </>
    );
};
